import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { get_purchases } from '../../redux/actions/user';
import {Link, useNavigate} from 'react-router-dom';
import UploadVoucherModal from './uploadVoucher';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faAngleRight, faTimes} from "@fortawesome/free-solid-svg-icons";
import {SwiperSlide} from "swiper/react";
import ItemProducto from "../../widgets/item_producto";

const UserPurchases = ({
    purchases,
    get_purchases,
    current_page,
    last_page,
    links,
    peticion_purchases
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [voucherUrl, setVoucherUrl] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        get_purchases(1);
    }, [get_purchases]);

    useEffect(() => {
        if (!peticion_purchases) {  // Si no está haciendo la petición de compras
            get_purchases(1);  // Vuelve a cargar las compras
        }
    }, [peticion_purchases, get_purchases]);

    const translateState = (state) => {
        switch (state) {
            case 'awaiting':
                return 'Pendiente';
            case 'accepted':
                return 'Aceptada';
            case 'canceled':
                return 'Cancelada';
            default:
                return state;
        }
    };

    const formatDate = (date) => {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString('es-ES', options);
    };

    const getStateColor = (state) => {
        switch (state) {
            case 'en espera':
                return 'bg-yellow-500 text-white';
            case 'aceptado':
                return 'bg-green-500 text-white';
            case 'preparado':
                return 'bg-green-500 text-white';
            case 'en camino':
                return 'bg-blue-500 text-white';
            case 'entregado':
                return 'bg-gray-500 text-white';
            case 'cancelado':
                return 'bg-red-500 text-white';
            case 'devolucion':
                return 'bg-orange-500 text-white';
            default:
                return 'bg-gray-500 text-white';
        }
    };

    const verifyShowVoucher = (purchase) => {
        if (purchase.qr_to_pay != null && purchase.payment_method_id == 1) {
            return true;
        } else {
            return false;
        }
    }

    const openModal = (voucherUrl) => {
        setVoucherUrl(voucherUrl);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVoucherUrl(null);
    };

    return (
        <div className="max-w-6xl mx-xl-auto mt-12 mx-4 p-4 bg-white rounded-xl">
            <h2 className="text-2xl font-bold mb-4 text-ecoprimary1">Compras pendientes</h2>
            {
                purchases && purchases.length > 0 &&
                purchases.map((purchase, index) => (
                    <>
                        <div className="flex justify-between items-center pb-0.5 border-b border-ecoprimary1">
                            <div className="flex items-center">
                                <h2 className="text-lg font-bold text-ecoprimary1">{purchase.code}</h2>
                                <a href={purchase.whatsapp} target="_blank" className="ml-2 mb-2 btn btn-success" rel="noreferrer"> contactar por whatsapp</a>
                            </div>
                            <button> {purchase.delivery_state.name} </button>
                        </div>

                        <div className="w-25 my-3 p-2 ">
                            {purchase.products.map((product, index) => (
                                <ItemProducto
                                    product={product}
                                />
                            ))}
                        </div>
                    </>
                ))
            }

            <h2 className="text-2xl font-bold mb-4 text-ecoprimary1">Compras concluidas</h2>
            <h2 className="text-2xl font-bold mb-4 text-ecoprimary1">Compras canceladas</h2>
        </div>
    );
};

const mapStateToProps = state => ({
    purchases: state.User.purchases,
    current_page: state.User.current_page,
    last_page: state.User.last_page,
    links: state.User.links,
    peticion_purchases: state.User.peticion_purchases
});

export default connect(mapStateToProps, {get_purchases})(UserPurchases);
